import { observable } from 'mobx';

export type ToolMode = 'single' | 'continuous';

export class ToolSlot {
  @observable current: Tool | undefined;
}

export abstract class Tool {
  readonly title: string;
  private readonly mode: ToolMode;
  private readonly toolSlot: ToolSlot;

  constructor(title: string, mode: ToolMode, toolSlot: ToolSlot) {
    this.title = title;
    this.mode = mode;
    this.toolSlot = toolSlot;
  }

  get isActive(): boolean {
    return this.toolSlot.current === this;
  }

  async toggleActivated(): Promise<void> {
    if (this.isActive) {
      await this.deactivate();
    } else {
      await this.activate();
    }
  }

  async deactivate(): Promise<void> {
    if (this.isActive) {
      this.toolSlot.current = undefined;
      await this.onCancelOperation();
      // console.log('Deactivated', this.title);
    }
  }

  async activate(): Promise<void> {
    if (this.toolSlot.current) {
      await this.toolSlot.current.deactivate();
    }
    this.toolSlot.current = this;
    // console.log('Activated', this.title);

    try {
      if (this.mode === 'single') {
        await this.onExecuteOperation();
      } else if (this.mode === 'continuous') {
        while (this.mode === 'continuous') {
          await this.onExecuteOperation();
        }
      }
    } catch (error) {
      if (error && (error as Error).message === 'Input task cancelled.') {
        // do nothing, this is expected
      } else {
        throw error;
      }
    } finally {
      await this.deactivate();
    }
  }

  protected async onExecuteOperation(): Promise<void> {}

  protected async onCancelOperation(): Promise<void> {}
}
